export const API_ENDPOINT = process.env.REACT_APP_API_URL || "http://localhost:3000";
export const API_CABLE_ENDPOINT = process.env.REACT_APP_WS_URL || "ws://localhost:3000";